import jquery from 'jquery';
import _size from 'lodash/size';
import _toInteger from 'lodash/toInteger';
import _indexOf from 'lodash/indexOf';
import _kebabCase from 'lodash/kebabCase';
import _toNumber from 'lodash/toNumber';
import _merge from 'lodash/merge';
import _map from 'lodash/map';
import _forEach from 'lodash/forEach';
import _clone from 'lodash/clone';
import _replace from 'lodash/replace';
import _reduce from 'lodash/reduce';
import _reverse from 'lodash/reverse';
import _values from 'lodash/values';

import Error from '@/tools/error';
import Template from '@/template';

import '@/helpers/vhtml.js';

import selectors from '@/option-selector/default-selectors.json';
import classes from '@/option-selector/default-classes.json';

// Модульный флаг для контроля инициализации глобальных обработчиков
let _bindEventsInitialized = false;

/**
 * Объект отвечающий за работу опшн селектора
 *
 * @class
 * @memberof ProductInstance
 *
 * @param {Object} config - настройки
 * @param {Object} _Variants - WTF
 * @param {Boolean} _isSetVariant - WTF
 *
 * @return {Object} - instance
 */

var OptionSelector = function(config, _Variants, _isSetVariant) {
  var self = this;

  if (_isSetVariant) {
    return false;
  }

  self.settings = config.settings.optionSelector;
  self.selectors = selectors;
  self.classes = classes;
  self.$product = config.node;

  self.$nativeSelect = self._getNativeSelector();
  self.nativeOptions = self._getOptionsFromAttr();

  if (self.$nativeSelect && self.$nativeSelect[0].OptionSelector) {
    //console.debug('OptionSelector: constructor: we try init OptionSelector from another instance');
    return self;
  }

  self.$optionSelector = self._getOptionSelector();

  self.settings.images = config.images;
  self.images = self._getCombinedImages();
  self.variants = _Variants;

  self._fillEmptySelect();

  if (self.$nativeSelect) {
    self.$nativeSelect.each(function(index, el) {
      el.OptionSelector = self;
    });
  }
  if (self.$optionSelector) {
    self.$optionSelector.each(function(index, el) {
      el.OptionSelector = self;
    });
  }

  self._bindEvents();

  // Первый рендер откладываем до update() — см. ProductInstance (убираем тяжёлый Template+vhtml из синхронного конструктора).
  self._deferInitialSelectorRender = true;

  //console.debug('OptionSelector: constructor: self: ', self)

  return self;
};

/**
 * @description
 * Получаем ссылку на базовый селект
 *
 * @return {Node} - select Dom node
 */
OptionSelector.prototype._getNativeSelector = function() {
  var self = this;
  var _nativeSelector = self.$product.find(self.selectors.native.css);

  if (!_size(_nativeSelector)) {
    _nativeSelector = false;
  }

  if (!_nativeSelector && !self._checkInput().is('input')) {
    //console.warn('Вы не разметили Селектор Модификаций для блока: ', self.$product);
  }

  //console.warn('OptionSelector: _getNativeSelector: _nativeSelector: ', _nativeSelector);
  return _nativeSelector;
};

/**
 * @description
 * Получаем контейнер селектора. Если не создан - создаем.
 *
 * TODO: разобраться, что за черная магия тут творится?
 *
 * @return {Node|Boolean} - DOM node | false
 */
OptionSelector.prototype._getOptionSelector = function() {
  var self = this;
  var _wrapper = self.$optionSelector;

  if (!_wrapper && self.$nativeSelect) {
    _wrapper = self.$nativeSelect
      .after('<div class="' + self.classes.base + '" ' + self.selectors.rendered.attr + '/>')
      .next();
  } else {
    _wrapper = false;
  }

  return _wrapper;
};

/**
 * @description
 * Проверяем, есть ли считалка в разметке.
 *
 * TODO: нафига оно нам надо?? Оо
 *
 * @return {Boolean} - флаг
 */
OptionSelector.prototype._checkInput = function() {
  var self = this;
  var _checkInput = null;

  _checkInput = self.$product.find('[name="variant_id"]');

  if (_checkInput.length > 1) {
    console.warn('2 name="variant_id"', _checkInput);
  }

  return _checkInput;
};

/**
 * @description
 * Основная обертка
 *
 * TODO: убрать из цикла поиск по дочерним элементам
 *
 * @return {void}
 */
OptionSelector.prototype._renderSelector = function() {
  var self = this;
  var withCustomTypes = false;
  var optionsHTML = '';

  if (self.$nativeSelect) {
    if (self.settings.hideSelect) {
      self.$nativeSelect.hide();
    } else {
      self.$nativeSelect.show();
    }
  }

  if (!self.$optionSelector) {
    return false;
  }

  // Если в настройках не отключили отображение селекторов
  if (self.settings.showVariants) {
    //  собираем отрендеренные селекторы
    optionsHTML = _reduce(self.variants.options._getOptions(), function(html, value, index) {
      if (value.id) {
        var __config = self.variants.getLevel(index);
        html += self._renderOption(__config);
        if (jquery('[data-template-id="' + __config.renderType + '"]').length) {
          withCustomTypes = true;
        }
      }

      return html;
    }, '');
  }
  //console.debug('optionSelector: _renderSelector: optionsHTML', optionsHTML);
  try {
    if (!withCustomTypes) {
      self.$optionSelector.vhtml(optionsHTML || '');
    } else {
      self.$optionSelector.html(optionsHTML);
    }
  } catch (error) {
    console.warn(error);
    self.$optionSelector.html(optionsHTML);
  }

  return;
};

/**
 * @description
 * Рендер разметки отдельной опции.
 *
 * @param {Object} option - информация по опции
 *
 * @return {String} - собранный шаблон опции
 */
OptionSelector.prototype._renderOption = function(option) {
  var self = this;
  var result = '';
  var _option = self._prepareOption(option);
  var _defaultRenderType = (self.nativeOptions.default) ? self.nativeOptions.default : option.renderType;
  var _renderType = (self.nativeOptions[option.title]) ? self.nativeOptions[option.title] : _defaultRenderType;

  //console.debug('OptionSelector: _renderOption: option: ', option);
  //console.debug('OptionSelector: _renderOption: _option: ', _option);

  //  если не получили шаблон
  if (!_renderType) {
    throw new Error('ErrorOptionSelector', 'ошибка в получении шаблона');
  }

  try {
    result = Template.render(_option, _renderType);
  } catch (e) {
    console.log(e);
    result = Template.render(_option, _defaultRenderType);
  }

  return result;
};

/**
 * @description
 * Прибиваем события
 * Использует модульный флаг для предотвращения повторной инициализации
 *
 * @return {void}
 */
OptionSelector.prototype._bindEvents = function() {
  var self = this;

  if (_bindEventsInitialized) {
    return false;
  }

  _bindEventsInitialized = true;

  self._bindSetVariant();
  self._bindOptionTriggers();
};

/**
 * @description
 * Обновляем состояние по выбранному варианту
 *
 * @param {Number} variant_id - Id варианта
 *
 * @return {void}
 */
OptionSelector.prototype.update = function(variant_id) {
  var self = this;

  if (!self.$nativeSelect) {
    return;
  }

  //console.warn('OptionSelector: update: self: ', self);
  self.$nativeSelect.val(variant_id);

  if (self._deferInitialSelectorRender) {
    queueMicrotask(function() {
      if (!self._deferInitialSelectorRender) {
        return;
      }
      self._deferInitialSelectorRender = false;
      self._renderSelector();
    });
  } else {
    self._renderSelector();
  }

  return;
};

/**
 * @description
 * Слушаем изменения в нативном селекте
 * Использует глобальное делегирование на document для всех селектов
 *
 * @return {void}
 */
OptionSelector.prototype._bindSetVariant = function() {
  var self = this;

  // Глобальное делегирование для всех option selector'ов на странице
  jquery(document).on('change', self.selectors.native.css, function(event) {
    // Быстрая проверка наличия OptionSelector перед обработкой
    if (!this.OptionSelector) {
      return;
    }

    event.preventDefault();

    var $select = jquery(this);
    var variantId = _toInteger($select.val());
    var _optionSelector = this.OptionSelector;

    //console.debug('OptionSelector: _bindSetVariant: on: _optionSelector: ', _optionSelector);
    _optionSelector.variants.setVariant(variantId);
  });
};

/**
 * @description
 * Слушаем изменения в селекторах модификаций
 * Использует глобальное делегирование на document для всех опций
 *
 * @return {void}
 */
OptionSelector.prototype._bindOptionTriggers = function() {
  var self = this;

  // Глобальное делегирование для всех option selector'ов на странице
  jquery(document).on('change click', self.selectors.option.css, function(event) {
    // Используем closest() вместо parents().first() для оптимизации
    var renderedElement = jquery(this).closest(self.selectors.rendered.css)[0];

    // Быстрая проверка наличия OptionSelector перед обработкой
    if (!renderedElement || !renderedElement.OptionSelector) {
      return false;
    }

    event.preventDefault();

    var $option = jquery(this);
    var _optionSelector = renderedElement.OptionSelector;
    var $data = $option.data();
    var option = {};
    var _data = {};

    jquery.each($data, function(indexInArray) {
      var numberValues = [ 'valueId', 'optionId', 'optionBind' ];
      if (_indexOf(numberValues, indexInArray) > -1) {
        $data[indexInArray] = _toNumber($option.attr('data-' + _kebabCase(indexInArray)));
        $option.data(indexInArray, $data[indexInArray]);
      }
    });
    //console.log('OptionSelector: _bindOptionTriggers: on: _optionSelector: ', _optionSelector);

    if ($option.is('select') && event.type === 'click') {
      return false;
    }

    if ($option.is('select')) {
      //console.log('yap! it\'s a fucking select');
      _data = $option.find(':selected').data();
      _data.valuePosition = _toInteger($option.val());
      _merge($data, _data);
    }
    //console.debug('OptionSelector: _bindOptionTriggers: $data: ', $data);

    option = {
      option_name_id: $data.optionBind,
      position: $data.valuePosition,
      option_id: $data.optionId,
      value_id: $data.valueId,
    };
    //console.debug('OptionSelector: _bindOptionTriggers: option: ', option);

    _optionSelector.variants.setOption(option);
  });
};

/**
 * @description
 * Устанавливаем настройки
 *
 * @param {Object} settings - объект с настройками
 *
 * @return {void}
 */
OptionSelector.prototype.setConfig = function(settings) {
  var self = this;

  self.settings = _merge(self.settings, settings);
  // Сбрасываем кэш images при изменении настроек
  self._imagesCacheValid = false;
  self.images = self._getCombinedImages();

  self._deferInitialSelectorRender = false;
  self._renderSelector();

  return;
};

/** @private */
OptionSelector.prototype._getOptionsFromAttr = function() {
  var self = this;
  var result = {};

  try {
    var result = self.$nativeSelect.data(self.selectors.native.data) || {};
  } catch (e) {
    return result;
  }

  return result;
};

/**
 * @description
 * Готовим опцию для рендера. Нормализуем для различных версии и прочее.
 *
 * @param {Object} option - опция для нормализации.
 *
 * @return {Object} - опция со всеми полями и состояниями.
 */
OptionSelector.prototype._prepareOption = function(option) {
  var self = this;
  var _option = Object.assign({}, option);

  _option.images = self.images;
  _option.fileUrl = self.settings.fileUrl;
  _option.fullFileUrl = self.settings.fullFileUrl;
  _option.initOption = self.settings.initOption;

  // Подтягиваем классы
  _option.classes = Object.assign({}, self.classes.option);
  _option.classes.option = _option.classes.option + ' ' + _option.classes.option + '-' + _option.handle;

  _option.values = _map(option.values || [], function(_value) {
    var valueCopy = Object.assign({}, _value);

    return self._prepareValue(valueCopy, _option);
  });

  // и биндим все говно для обратной совместимости в отдельное поле
  _option.option = _clone(_option);

  // Кэшируем индекс вариантов по option_value.id для оптимизации (O(n) вместо O(n³))
  if (!self._variantsByOptionValueId) {
    self._variantsByOptionValueId = new Map();
    let variants = _reverse(_values(self.variants.variants));
    _forEach(variants, function(variant) {
      _forEach(variant.option_values, function(option_value) {
        // Берем последний вариант (т.к. массив реверснут)
        if (!self._variantsByOptionValueId.has(option_value.id)) {
          self._variantsByOptionValueId.set(option_value.id, variant);
        }
      });
    });
  }

  _forEach(_option.values, function(value, key) {
    const currentVariant = self._variantsByOptionValueId.get(value.id) || null;

    value.titleWithoutQuotes = _replace(value.title, /\"/g, '\'');
    value.variant = currentVariant;
    value.imageFromVariant = currentVariant ? currentVariant.first_image : null;
  });

  // console.debug('OptionSelector: _prepareOption: _option: ', _option);

  return _option;
};

/**
 * @description
 * Склеиваем картинки из разных источников по схеме в `imagesCombineOrder`
 *
 * @return {Object} - объект с картинками
 */
OptionSelector.prototype._getCombinedImages = function() {
  var self = this;
  if (!self.settings) {
    console.warn('Ошибка установки настроек, проверьте вызов setConfig. Должно быть вызвано после подключения commonjs.');

    return {};
  }

  // Кэширование: если images уже есть и кэш валиден, возвращаем его
  if (self._cachedImages && self._imagesCacheValid) {
    return self._cachedImages;
  }

  var _combineOrder = self.settings.imagesCombineOrder;
  var _images = {};

  _images = _reduce(_combineOrder, function(result, sourceName) {
    _merge(result, self.settings[sourceName]);

    return result;
  }, {});

  _images = _reduce(_images, function(result, value, key) {
    var name = _replace(key, 'й', 'й');
    result[name] = value;

    return result;
  }, {});

  // Сохраняем в кэш
  self._cachedImages = _images;
  self._imagesCacheValid = true;

  return _images;
};

/**
 * @description
 * Готовим значение опции
 *
 * @param {Object} value - исходное состяние Значения опции
 * @param {Object} option - описание опции
 *
 * @return {Object} - готовый к рендеру объект
 */
OptionSelector.prototype._prepareValue = function(value, option) {
  var self = this;
  var _classes = {
    base: self.classes.option.value,
    active: '',
    disabled: '',
  };
  var _state = '';
  var _selected = false;
  var _controls = '';

  // Провереям, выбрана ли опция
  if (value.position == option.selected && option.initOption) {
    _selected = true;
    _classes.active = self.classes.states.active;
    _state += ' selected checked ';
  }

  if (value.disabled) {
    _classes.disabled = self.classes.states.disabled;
    _state += ' disabled ';
  }

  _classes.state = _classes.active + ' ' + _classes.disabled;
  _classes.all = _classes.base + ' ' + _classes.state;

  _controls = 'data-option-bind="' + option.id + '" data-option-id="' + option.id + '" data-value-id="' + value.id + '" value="' + value.position + '"';

  return _merge(value, {
    selected: _selected,
    controls: _controls,
    classes: _classes,
    state: _state,
  });
};

/**
 * @description
 * Заполняет нативный select[data-product-variants] опциями из данных вариантов,
 * если select является тегом select и у него нет ни одной опции.
 * Безопасен для товаров с одним вариантом (input hidden) и для уже заполненных селектов.
 *
 * @return {void}
 */
OptionSelector.prototype._fillEmptySelect = function() {
  var self = this;
  var $select;
  var variants;

  if (!self.$nativeSelect) {
    return;
  }

  $select = self.$nativeSelect.filter('select').first();
  if (!$select.length) {
    return;
  }

  if ($select[0].options.length > 0) {
    return;
  }

  if (!self.variants || !self.variants.variants) {
    return;
  }

  variants = _values(self.variants.variants);

  if (!variants.length) {
    return;
  }

  _forEach(variants, function(variant) {
    var option = document.createElement('option');
    option.value = variant.id;
    option.textContent = variant.title;
    $select[0].appendChild(option);
  });

  return;
};

export default OptionSelector;
